import { makeStyles } from "@material-ui/core";
const styles = makeStyles({
    container:{display:'flex',justifyContent:'center', alignItems:'center', width:'100%', height:'100%', border:'1px solid black'},
    root: { display: 'flex', flexDirection: 'column'},
    header: {padding:'0.5rem 1rem', backgroundColor: '#08090A', fontSize: '1.125rem', fontWeight: '400', color: '#FFFFFF', display:'flex',justifyContent:'space-between' },
    content: { backgroundColor: '#FFFFFF', padding:'0.5rem 1rem', minHeight: 420 },
})
export default styles;